module.exports = __webpack_public_path__ + "media/partners/pb98-ce935ac8.svg";